// src/components/charts/CorrelationChart.jsx
import React from 'react';
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label
} from 'recharts';

const CorrelationChart = ({
  data,
  xMetric,
  yMetric,
  color = '#8884d8',
  units = {}
}) => {
  const getUnitSymbol = (metric) => {
    const unitMap = {
      temperature: units.temperature === 'C' ? '°C' : '°F',
      humidity: '%',
      pressure: units.pressure === 'hPa' ? 'hPa' : 'inHg',
      dewPoint: units.temperature === 'C' ? '°C' : '°F',
      heatIndex: units.temperature === 'C' ? '°C' : '°F',
      wetBulb: units.temperature === 'C' ? '°C' : '°F',
      absoluteHumidity: 'g/m³',
      airDensity: 'kg/m³'
    };
    return unitMap[metric] || '';
  };

  const formatTooltip = (value, name) => {
    return `${value.toFixed(2)} ${getUnitSymbol(name)}`;
  };

  // Transform data for scatter plot
  const scatterData = data.map(item => ({
    x: item[xMetric],
    y: item[yMetric],
    timestamp: item.timestamp
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <ScatterChart margin={{ top: 20, right: 30, bottom: 40, left: 40 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis 
          dataKey="x" 
          name={xMetric}
          type="number"
        >
          <Label 
            value={`${xMetric} (${getUnitSymbol(xMetric)})`} 
            position="bottom" 
            offset={20}
          />
        </XAxis>
        <YAxis 
          dataKey="y" 
          name={yMetric}
          type="number"
        >
          <Label 
            value={`${yMetric} (${getUnitSymbol(yMetric)})`} 
            angle={-90} 
            position="left" 
            offset={-20}
          />
        </YAxis>
        <Tooltip 
          formatter={(value, name) => [formatTooltip(value, name === 'x' ? xMetric : yMetric), name === 'x' ? xMetric : yMetric]}
          labelFormatter={(label) => new Date(scatterData[label].timestamp).toLocaleString()}
        />
        <Scatter 
          data={scatterData} 
          fill={color}
          name={`${xMetric} vs ${yMetric}`}
        />
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default CorrelationChart;